import { useTheme } from "../../contexts/ThemeContext";

const SunIcon = () => (
  <svg aria-hidden="true" height="16" viewBox="0 0 16 16" width="16">
    <path
      fill="currentColor"
      d="M8 11.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 0a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 8 0Zm0 13.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 8 13.5ZM2.343 1.282a.75.75 0 0 1 1.061 0l.707.707A.75.75 0 0 1 3.05 3.05l-.707-.707a.75.75 0 0 1 0-1.061Zm9.546 9.546a.75.75 0 0 1 1.061 0l.707.707a.75.75 0 0 1-1.061 1.061l-.707-.707a.75.75 0 0 1 0-1.061ZM0 8a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 0 8Zm13.5 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 13.5 8ZM3.404 12.596a.75.75 0 0 1-1.061-1.061l.707-.707a.75.75 0 0 1 1.061 1.061l-.707.707Zm9.546-9.546a.75.75 0 1 1-1.061-1.061l.707-.707a.75.75 0 0 1 1.061 1.061l-.707.707Z"
    />
  </svg>
);

const MoonIcon = () => (
  <svg aria-hidden="true" height="16" viewBox="0 0 16 16" width="16">
    <path
      fill="currentColor"
      d="M9.598 1.591a.75.75 0 0 1 .785.944 5.75 5.75 0 0 0 3.082 6.93.75.75 0 0 1 .218 1.22A6.75 6.75 0 1 1 5.315 2.317a.75.75 0 0 1 1.22.218 5.75 5.75 0 0 0 3.063-.944ZM5.534 4.173A5.25 5.25 0 1 0 11.827 10.466 7.25 7.25 0 0 1 5.534 4.173Z"
    />
  </svg>
);

const ThemePicker = () => {
  const { isDark, toggleTheme } = useTheme();
  const label = `Switch to ${isDark ? "light" : "dark"} mode`;

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
};

export default ThemePicker;
